// translations/ko.ts
import { TranslationKeys } from '../index';

export const ko: TranslationKeys = {
  header: {
    tutorialButton: "튜토리얼",
    currentLanguage: "현재"
  },
  hero: {
    title: "지금 스도쿠 대전을 플레이하세요!",
    description: "다른 어떤 것과도 비교할 수 없는 스도쿠 도전에 대비하세요! 혼자 연습하거나 친구와 대결하세요 — 지금 다운로드하여 짜릿함을 경험하세요!",
    howToPlay: "게임 방법",
    discordButton: "Discord 참여하기",
    googlePlay: {
      topText: "에서 받기",
      bottomText: "Google Play"
    },
    appStore: {
      topText: "에서 다운로드",
      bottomText: "App Store"
    },
    botButtonShow: "도움이 필요하신가요? 저희 봇에게 물어보세요!",
    botButtonHide: "도우미 숨기기"
  },
  footer: {
    followUs: "팔로우하기",
    handle: "@SUDOKU.VS",
    copyright: "© 2024 Sudoku VS. 모든 권리 보유."
  },
  beginnersGuide: {
    modalTitle: "초보자 가이드",
    originsTab: "스도쿠의 기원",
    basicsTab: "스도쿠 기초",
    rulesTab: "대전 게임 규칙",
    origins: {
      bulletOne: "라틴 방진에서 영감을 받아 1979년 하워드 간스에 의해 처음 출판되었습니다.",
      bulletTwo: "1980년대 일본에서 인기를 얻으며 '스도쿠'로 이름이 바뀌었습니다. 2000년대에 세계적인 명성을 얻었습니다.",
      bulletThree: "9개의 3x3 하위 그리드가 있는 9x9 그리드; 행, 열 또는 하위 그리드에서 반복 없이 1부터 9까지 채웁니다.",
      bulletFour: "수많은 변형과 새로운 도전으로 수백만 명에게 사랑받고 있습니다.",
      gridSize: {
        four: "4 X 4",
        six: "6 X 6",
        nine: "9 X 9",
      }
    },
    basics: {
      fillMissing: "빠진 숫자를 채워주세요!",
      correct: "정답입니다!",
      incorrect: "오답입니다",
      instructions: "강조 표시된 공간에 올바른 숫자를 입력하여 3X3 퍼즐을 완성하세요. 각 행, 열, 상자에는 각 숫자가 정확히 한 번만 포함되어야 합니다. 올바른 숫자를 선택하세요. 신중하게 선택하세요!",
      feedbackCorrect: "첫 번째 상자를 해결했습니다!",
      feedbackIncorrect: "다시 시도하세요!",
      basicsStep2: {
        instructions: "강조 표시된 공간에 올바른 숫자를 선택하여 4X4 퍼즐을 완성하세요. 각 행, 열, 상자에는 각 숫자가 정확히 한 번만 포함되어야 합니다. 올바른 숫자를 선택하세요. 신중하게 선택하세요!",
        feedbackCorrect: "잘하고 있어요!"
      },
      basicsStep3: {
        instructions: "강조 표시된 공간에 올바른 숫자를 선택하여 4X4 퍼즐을 완성하세요. 각 행, 열, 상자에는 각 숫자가 정확히 한 번만 포함되어야 합니다. 올바른 숫자를 선택하세요. 신중하게 선택하세요!",
        feedbackCorrect: "완벽한 해결책입니다!",
        feedbackIncorrect: "오답입니다 - 다시 시도하세요!"
      },
      congratulations: {
        title: "축하합니다!",
        subtitle: "스도쿠 기초 튜토리얼을 성공적으로 완료했습니다! 당신의 헌신과 노력이 결실을 맺었으며, 이제 자신감을 가지고 스도쿠 퍼즐에 도전할 수 있는 필수 기술을 갖추게 되었습니다.",
        nextStepsTitle: "다음 단계",
        nextStepsText: "이제 당신의 기술을 시험해 볼 시간입니다! 오늘 스도쿠 게임을 다운로드하고 다양한 퍼즐에 빠져보세요. 빠른 싱글 게임을 선호하든, 친선 경쟁에 참여하고 싶든, 싱글 모드 또는 상대와 대결하는 대전 모드에서 플레이할 수 있습니다.",
        ctaHeader: "게임 한 판 어떠세요?",
        ctaHighlight: "지금 다운로드하세요!",
        rulesTitle: "게임 규칙 마스터하기",
        rulesText: "시작하기 전에 Sudoku VS: 게임 규칙을 꼭 확인하세요. 규칙과 점수 시스템을 이해하면 상대와 플레이할 때 유리할 수 있습니다. 이 지식은 당신의 경험을 향상시키고 효과적으로 전략을 세우는 데 도움이 될 것입니다!"
      }
    },
    gameRules: {
      notification: {
        important: "중요: ",
        text: "최상의 경험을 위해 알림을 활성화하세요!"
      },
      rulesHeader: "규칙",
      rulesList: {
        rule1_pre: "친선 또는 랜덤 매치 초대를 ",
        rule1_strong: "수락하거나 생성합니다.",
        rule1_post: "",
        rule2_pre: "플레이어는 ",
        rule2_strong: "무작위로 선택되어 먼저 시작합니다.",
        rule3: "보드가 완성될 때까지 플레이어는 차례를 번갈아 가며 진행합니다.",
        rule4_pre1: "각 턴은 ",
        rule4_strong1: "60초 동안 지속되며,",
        rule4_pre2: " 턴당 ",
        rule4_strong2: "5개의 숫자 제한이 있습니다.",
        rule5_pre: "턴당 ",
        rule5_strong: "1개의 힌트",
        rule5_post: "만 허용됩니다.",
        rule6_pre: "가장 ",
        rule6_strong: "높은 점수를 얻은 플레이어가",
        rule6_post: " 게임에서 승리합니다.",
        rule7_pre: "동점일 경우,",
        rule7_strong_pre: "더 많은 입력을 한",
        rule7_pre2: " 플레이어가 ",
        rule7_strong_post: "게임에서",
        rule7_post: " 승리합니다.",
        rule8: "24시간 이내에 턴을 끝내지 않으면 자동으로 게임을 포기하게 됩니다."
      },
      rulesWarning: "24시간 이내에 턴을 플레이하지 않으면 자동으로 게임을 포기하게 됩니다",
      gameControls: {
        header: "게임 컨트롤",
        list: {
          control1_pre: "게임을 포기하려면 ",
          control1_strong: "기권 깃발",
          control1_post: "을 사용하세요.",
          control2_pre: "실수를 수정하려면 ",
          control2_strong: "지우개",
          control2_post: "를 사용하세요.",
          control3_pre: "타이머가 끝나기 전에 모든 입력을 완료했다면 ",
          control3_strong: "턴 종료",
          control3_post: "를 사용하세요."
        }
      },
      scoring: {
        header: "점수 매기기",
        list: {
          score1_pre1: "올바른 숫자 배치에 대해 ",
          score1_strong1: "1점",
          score1_pre2: "을 획득합니다.",
          score1_span: "올바른",
          score1_post: "",
          score2_pre1: "잘못된 숫자 배치마다 ",
          score2_strong1: "1점",
          score2_pre2: "을 잃습니다.",
          score2_span: "잘못된",
          score2_post: "",
          score3_pre1: "해결된 각 행, 열, 상자에 대해 ",
          score3_strong1: "5점",
          score3_pre2: "을 획득합니다.",
          score3_span: "해결된",
          score3_post: ""
        }
      },
    },
    controller: {
      previous: "이전",
      of: " / ",
      close: "닫기",
      next: "다음",
      gameRules: "게임 규칙",
    },
  },
  tutorials: {
    modalTitle: "튜토리얼",
    tabs: {
      introduction: "소개",
      gettingStarted: "시작하기",
      vsFriends: "친구와 대결",
      howToPlay: "게임 방법",
    },
    messages: {
      loading: "튜토리얼 로드 중...",
      error: "튜토리얼 로드 오류:",
      fallback: "대체 데이터 사용 중...",
      empty: "이 섹션에 사용할 수 있는 튜토리얼이 없습니다.",
    },
  },
  cookieConsent: {
    title: "동의 기본 설정 관리",
    description: "저희는 귀하의 Sudoku VS 경험을 향상시키고, 트래픽을 분석하며, 맞춤형 광고를 제공하기 위해 쿠키를 사용합니다.",
    acceptAll: "모든 쿠키 수락",
    confirmChoices: "선택 확인",
    performance: {
      title: "성능 쿠키",
      description: "사용 분석을 통해 게임과 서비스를 개선하기 위한 데이터를 수집할 수 있습니다."
    },
    advertising: {
      title: "광고",
      adStorage: "기기에 광고 데이터 저장을 허용합니다",
      adMeasurement: "광고 측정을 위한 데이터 수집을 허용합니다",
      adPersonalization: "관심사에 따라 맞춤형 광고를 표시할 수 있습니다"
    },
    landing: {
        title: "쿠키 공지",
        description: "저희는 귀하의 Sudoku VS 경험을 향상시키고, 트래픽을 분석하며, 맞춤형 광고를 제공하기 위해 쿠키를 사용합니다. 계속하기 전에 허용할 쿠키를 설정할 수 있습니다.",
        acceptAll: "모든 쿠키 수락",
        customizeSettings: "설정 사용자 지정",
        fineprint: "\"모든 쿠키 수락\"을 클릭하면<br />Sudoku VS가 귀하의 기기에 쿠키를 저장하는 데 동의하는 것입니다."
    }
  },
languages: {
    en: "English",
    es: "Español", 
    fr: "Français",
    hi: "हिन्दी",
    bn: "বাংলা",
    pt: "Português",
    it: "Italiano",
    ru: "Русский",
    ja: "日本語",
    ko: "한국어"
},

  privacyPolicy: {
    modalTitle: "개인정보 처리방침",
    sections: {
      introduction: {
        title: "1. 소개",
        p1: "Sudoku VS에 오신 것을 환영합니다. 우리는 귀하의 개인정보를 보호하고 당사 웹사이트에서 긍정적인 경험을 보장하기 위해 최선을 다하고 있습니다. 이 개인정보 처리방침은 Sudoku 게임 플랫폼을 사용할 때 귀하의 정보를 어떻게 수집, 사용 및 보호하는지 설명합니다.",
        p2: "Sudoku VS를 사용함으로써 귀하는 이 정책에 따른 정보의 수집 및 사용에 동의하는 것으로 간주됩니다."
      },
      informationWeCollect: {
        title: "2. 수집하는 정보",
        p1: "우리는 서비스를 제공하고 개선하기 위해 다양한 유형의 정보를 수집합니다:",
        list: {
          usageData: "사용 데이터: 게임플레이 통계, 퍼즐 완료 시간, 플레이한 난이도 수준 및 게임 선호도를 포함하여 게임과 상호 작용하는 방법에 대한 정보를 자동으로 수집합니다.",
          deviceInfo: "기기 정보: Sudoku VS에 액세스하는 데 사용하는 기기 유형, 브라우저 유형, IP 주소 및 운영 체제를 포함한 기기 정보를 수집할 수 있습니다.",
          cookies: "쿠키 및 추적 데이터: 귀하의 경험을 향상시키고 분석 데이터를 수집하기 위해 쿠키 및 유사한 추적 기술을 사용합니다."
        }
      },
      howWeUseInfo: {
        title: "3. 정보 사용 방법",
        p1: "수집된 정보는 다음 목적으로 사용됩니다:",
        list: {
          gameImprovement: "게임 개선: 게임플레이 패턴을 분석하고 Sudoku 퍼즐, 난이도 알고리즘 및 전반적인 사용자 경험을 개선하기 위해.",
          performanceAnalytics: "성능 분석: 사용 추세를 모니터링 및 분석하고 서비스 효과를 측정하며 개선 영역을 식별하기 위해.",
          personalization: "개인화: 게임 선호도에 기반한 맞춤형 게임 추천 및 조정된 콘텐츠를 제공하기 위해.",
          technicalSupport: "기술 지원: 문제 해결, 버그 수정 및 플랫폼의 원활한 운영을 보장하기 위해."
        }
      },
      cookies: {
        title: "4. 쿠키 및 추적 기술",
        p1: "Sudoku VS는 귀하의 경험을 향상시키기 위해 쿠키를 사용합니다. 쿠키 기본 설정을 관리할 수 있는 옵션이 있습니다:",
        performanceCookies: {
          title: "성능 쿠키:",
          description: "이러한 쿠키를 통해 사용 분석을 통해 게임과 서비스를 개선하기 위한 데이터를 수집할 수 있습니다. 플레이어가 퍼즐과 어떻게 상호 작용하는지, 어떤 기능이 가장 인기 있는지, 어디를 개선할 수 있는지 이해하는 데 도움이 됩니다. 이 데이터는 게임플레이를 향상시키고 더 나은 Sudoku 경험을 만드는 데 필수적입니다."
        },
        advertisingCookies: {
          title: "광고 쿠키:",
          list: [
            "기기에 광고 데이터 저장 허용",
            "광고 측정 및 효과를 위한 데이터 수집 활성화",
            "관심사 및 게임 행동에 기반한 맞춤형 광고 표시 허용"
          ]
        },
        p2: "웹사이트를 처음 방문할 때 나타나는 쿠키 동의 배너를 통해 쿠키 기본 설정을 제어할 수 있습니다. 브라우저 설정을 통해 언제든지 설정을 변경할 수 있지만 특정 쿠키를 비활성화하면 웹사이트 기능에 영향을 미칠 수 있습니다."
      },
      thirdParty: {
        title: "5. 제3자 서비스",
        p1: "Sudoku VS는 다음 제3자 서비스와 통합됩니다:",
        gemini: {
          title: "Google Gemini AI 어시스턴트:",
          description: "당사의 도움말 봇은 내장 지식 베이스가 있는 Google Gemini로 구동되어 게임 관련 질문 지원, Sudoku 팁 제공 및 문제 해결을 도와줍니다. 봇과 상호 작용할 때 귀하의 쿼리는 Google 시스템에서 처리될 수 있습니다. 데이터 처리 방법에 대한 정보는 Google의 개인정보 처리방침을 참조하십시오."
        },
        youtube: {
          title: "YouTube 임베디드 동영상:",
          description: "튜토리얼 콘텐츠와 게임플레이 가이드를 웹사이트 내에서 직접 제공하기 위해 YouTube 동영상 오버레이를 사용합니다. 이러한 동영상과 상호 작용할 때 YouTube는 자체 개인정보 처리방침에 따라 데이터를 수집할 수 있습니다. Sudoku VS를 떠나지 않고 동영상을 시청할 수 있지만 YouTube의 추적 메커니즘이 여전히 적용될 수 있습니다."
        },
        advertising: {
          title: "광고 파트너:",
          description: "당사는 플랫폼에 광고를 표시하기 위해 제3자 광고 파트너와 협력합니다. 이러한 파트너는 맞춤형 광고 목적으로 귀하의 브라우징 활동에 대한 정보를 수집하기 위해 쿠키 및 유사한 기술을 사용할 수 있습니다."
        }
      },
      dataSecurity: {
        title: "6. 데이터 보안",
        p1: "당사는 귀하의 데이터 보안을 심각하게 받아들이고 무단 액세스, 변경, 공개 또는 파괴로부터 귀하의 정보를 보호하기 위해 적절한 기술적 및 조직적 조치를 구현합니다. 그러나 인터넷을 통한 전송 또는 전자 저장 방법은 100% 안전하지 않습니다.",
        p2: "당사 웹사이트는 업계 표준 보안 프로토콜을 사용하며 안전한 브라우징 경험을 보장하기 위해 GoDaddy 보안 인증으로 검증되었습니다."
      },
      privacyRights: {
        title: "7. 개인정보 권리",
        p1: "귀하의 개인정보와 관련하여 특정 권리가 있습니다:",
        list: {
          access: "접근: 당사가 보유한 귀하에 대한 데이터에 대한 정보를 요청할 수 있습니다",
          correction: "정정: 부정확한 정보의 정정을 요청할 수 있습니다",
          deletion: "삭제: 법적 의무를 조건으로 데이터 삭제를 요청할 수 있습니다",
          optOut: "옵트아웃: 쿠키 기본 설정을 통해 맞춤형 광고에서 옵트아웃할 수 있습니다",
          portability: "데이터 이동성: 휴대 가능한 형식으로 데이터 사본을 요청할 수 있습니다"
        }
      },
      childrenPrivacy: {
        title: "8. 아동 개인정보",
        p1: "Sudoku VS는 일반 관객을 위해 설계되었습니다. 당사는 13세 미만 아동으로부터 고의로 개인정보를 수집하지 않습니다. 부모 또는 보호자이며 자녀가 당사에 개인정보를 제공했다고 생각되는 경우 적절한 조치를 취할 수 있도록 당사에 연락하십시오."
      },
      changes: {
        title: "9. 개인정보 처리방침 변경",
        p1: "당사는 관행 변경 또는 법적, 운영, 규제상의 이유로 이 개인정보 처리방침을 수시로 업데이트할 수 있습니다. 중요한 변경 사항이 있는 경우 이 페이지에 새로운 개인정보 처리방침을 게시하고 아래 '마지막 업데이트' 날짜를 업데이트하여 알려드립니다.",
        p2: "당사가 귀하의 정보를 어떻게 보호하는지 알기 위해 정기적으로 이 개인정보 처리방침을 검토하는 것을 권장합니다."
      },
      contact: {
        title: "10. 문의하기",
        p1: "이 개인정보 처리방침 또는 데이터 관행에 관한 질문, 우려 사항 또는 요청이 있는 경우 당사에 연락하십시오:",
        email: "이메일: privacy@sudoku.vs",
        website: "웹사이트: www.sudoku.vs",
        p2: "가능한 한 빨리 문의에 응답하겠습니다."
      }
    },
    footer: {
      lastUpdated: "마지막 업데이트: 2025년 10월 10일",
      effectiveDate: "시행일: 2025년 10월 10일"
    }
  },
  copywright: {
    text: '저작권 © 2025 Software Architects Ltd. 모든 권리 보유.'
  }
};